import { field, date, relation,text } from '@nozbe/watermelondb/decorators';
import { POS_ORDERS_LINE_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class PosOrderLine extends Model {
    static table = POS_ORDERS_LINE_SCHEMA;

    static associations = {
        pos_orders: { type: 'belongs_to', key: 'pos_order_id' },
        business: { type: 'belongs_to', key: 'business_id' },
        stock: { type: 'belongs_to', key: 'stock_id' },
    }

    @field('selling_price') selling_price;
    @field('cost_price') cost_price;
    @field('quantity') quantity;
    @text('name') name;
    @text('unit') unit;
    @text('type') type;

    @date('transacted_at') transacted_at;

    @relation('pos_orders', 'pos_order_id') pos_orders;
    @relation('business', 'business_id') business;
    @relation('stock', 'stock_id') stock;

}